import React from 'react'
import { MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { NotifyProvider } from 'utils/useNotify'
import theme from 'theme'
import DateFnsUtils from '@date-io/date-fns'
import format from 'date-fns/format'
import enGBLocale from 'date-fns/locale/en-GB'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

class LocalizedUtils extends DateFnsUtils {
  getCalendarHeaderText(date: Date): string {
    return format(date, 'LLLL, yyyy', { locale: this.locale })
  }
}

export const Providers: React.FC = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <NotifyProvider>
        <MuiPickersUtilsProvider utils={LocalizedUtils} locale={enGBLocale}>
          {children}
        </MuiPickersUtilsProvider>
      </NotifyProvider>
    </MuiThemeProvider>
  )
}
